// extracted by mini-css-extract-plugin
export default {"container":"yq-z","brandName":"zq-z","productName":"Aq-z","productNamePdpEnhancements":"Bq-z","breakLongProductName":"Cq-z"};